<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Link 2 Off" class="d-icon d-icon--link-2-off" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 3.5a.5.5 0 0 1 .5-.5h1a3 3 0 0 1 2.4 4.8.5.5 0 1 1-.8-.6A2 2 0 0 0 8.5 4h-1a.5.5 0 0 1-.5-.5Z"/><path d="M2.086 4.586A2 2 0 0 0 3.5 8h1a.5.5 0 1 1 0 1h-1a3 3 0 0 1-1.026-5.819L.647 1.354a.5.5 0 1 1 .707-.708l10 10a.5.5 0 0 1-.707.708L5.793 6.5H4a.5.5 0 0 1 0-1h.793l-1.49-1.49a2 2 0 0 0-1.217.576Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconLink2Off',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
